import { useEffect } from 'react';
import styled from '@emotion/styled';
import { BasicFlex } from '../../utils/Common';

import { startCase } from 'lodash';

import { Button, Card } from '@mui/material';

import useReportStore from '../../store/reports';

import PlayCircleOutlineRoundedIcon from '@mui/icons-material/PlayCircleOutlineRounded';

import ArrowUpwardRoundedIcon from '@mui/icons-material/ArrowUpwardRounded';
import ArrowDownwardRoundedIcon from '@mui/icons-material/ArrowDownwardRounded';

import SimpleChip from '../../utils/utilities/SimpleChip';

import FilterChip from './FilterFormComponents/FilterChip';

import { useQuery } from '@tanstack/react-query';

import { createReport } from './apiService';

import { formatDisplay } from '../../utils/util';

const SearchPanel = styled.div`
  background-color: ${props => props.theme.colors.white};
  border: 1px solid ${props => props.theme.colors.border};
  border-radius: 8px;
  padding: 2rem;
  gap: 1rem;
  margin-top: .5rem;
`;

const ResultPanel = styled(BasicFlex)`
  margin-top: 2rem;
  gap: 2rem;
  flex-direction: column;
`;

const SummaryCard = styled(BasicFlex)`
  border-top: 4px solid ${props => props?.$color || props.theme.colors.border};
  border-radius: 5px;
  padding: 2rem;
  width: auto;
  flex-grow: 1;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);
  background-color: ${props => props.theme.colors.white};
  /* max-width: 40rem; */
  transition: all 0.2s ease-in-out;

  &:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    transform: translateY(-2px);
  }
`;

const SummaryAmount = styled.div`
  font-size: 2.6rem;
  font-weight: 500;
  /* color: ${props => props.theme.colors.mildText}; */
`

const FilterRibbonContainer = styled(BasicFlex)`
  margin: 1.5rem 0;
  justify-content: flex-start;
  gap: 1rem;
`

const TopCountTableStyles = styled(Card)`

`
const TopCountTableDescription = styled(BasicFlex)`
  padding: 1.6rem;
`

const TopCountTableTitle = styled.div`
  font-weight: 600;
  font-size: 1.5rem;
`;

const TopCountTableHeader = styled(BasicFlex)`
  border-bottom: 1px solid ${props => props.theme.colors.border};
  padding: 1rem 1.6rem;
  gap: .5rem;
  background-color: ${props => '#f0f1f4' || props.theme.colors.headerBg};
  color: ${props => props.theme.colors.mildText};
  text-transform: uppercase;
  font-weight: 600;
  font-size: 1.3rem;
  letter-spacing: .6px;

  div {
    flex-grow: 1;
    flex-basis: 0;
  }
`
const TopCountTableRow = styled(BasicFlex)`
  border-bottom: 1px solid ${props => props.theme.colors.border};
  padding: 1rem 1.6rem;
  gap: .5rem;

  div {
    flex-grow: 1;
    flex-basis: 0;
  }
`

const TCCell = styled.div`
  text-align: ${props => props.$align || "left"};
`

const TopCountTable = ({ children, headers, data }) => {
  return (
    <TopCountTableStyles variant='outlined' sx={{width: "100%", borderRadius: "5px"}}>
      {children}
      <TopCountTableHeader>
        {headers?.map((h, i) => <TCCell $align={h?.align} key={h?.id}>{h?.label}</TCCell>)}
      </TopCountTableHeader>
      {data?.map((d, i) => (
        <TopCountTableRow key={i}>
          {headers?.map((h, j) => <TCCell $align={h?.align} key={h?.id}>{formatDisplay(h, d)}</TCCell>)}
        </TopCountTableRow>
      ))}
    </TopCountTableStyles>
  )
}

const ReportButton = () => {
  const reportType = useReportStore(state => state.reportType);
  const convertFilters = useReportStore(state => state.convertFilters);
  const convertStaticFilters = useReportStore(state => state.convertStaticFilters);
  const filterString = useReportStore(state => state.filterString);
  const staticFilterString = useReportStore(state => state.staticFilterString);
  const setReportResults = useReportStore(state => state.setReportResults);
  const setReportLoading = useReportStore(state => state.setReportLoading);

  let fs = filterString[reportType];
  let sfs = staticFilterString[reportType];

  const { data, isLoading, refetch } = useQuery({
    queryKey: ["report", reportType, fs, sfs],
    queryFn: () => createReport(reportType, fs, sfs),
    enabled: !!fs
  })

  useEffect(() => {
    if (data) {
      setReportResults(data, reportType);
    }
  }, [data])

  useEffect(() => {
    if (isLoading) {
      setReportLoading(true, reportType);
    } else {
      setReportLoading(false, reportType);
    }
  }, [isLoading])

  const runReport = () => {
    convertFilters(reportType);
    convertStaticFilters(reportType);
    refetch();
  }

  return (
    <Button variant="contained" startIcon={<PlayCircleOutlineRoundedIcon />} color="secondary" onClick={runReport} loading={isLoading}>
      Run Report
    </Button>
  )
}

const TrajectoryIndicator = ({ value }) => {
  let ind = value > 0 ? "up" : "down";
  let Icon = ind === "up" ? ArrowUpwardRoundedIcon : ArrowDownwardRoundedIcon;
  let color = ind === "up" ? "success" : "error";
  return (
    <SimpleChip label={<BasicFlex width="auto"><Icon fontSize="small" sx={{fontSize: "1.4rem"}} /> {Math.abs(value)}%</BasicFlex>} palette={color} size="small" />
  )
}

const FilterRibbon = () => {
  const reportType = useReportStore(state => state.reportType);
  const EMPTY = {};
const filters = useReportStore(
  state => state.filters?.[reportType] || EMPTY
);

  return (
    <FilterRibbonContainer>
      {Object.keys(filters).map((el) => {
        // let label = filters.find(cur => cur.id === el).label
        let obj = filters[el]
        
        return (
          <FilterChip key={el} id={el} filter={obj} label={el} />
          );
      })}
    </FilterRibbonContainer>
  )

}



export { 
  SearchPanel,
  ResultPanel,
  SummaryCard,
  SummaryAmount,

  TopCountTable,
  TopCountTableTitle,
  TopCountTableDescription,
  TopCountTableHeader,
  TopCountTableRow,

  ReportButton,
  TrajectoryIndicator,
  FilterRibbon
};